import { useTranslation } from 'react-i18next';

import { Button } from '~/chords/Button';
import { Icon } from '~/chords/Icon';
import { Tooltip } from '~/components';
import { cn } from '~/lib/cn';
import { env } from '~/lib/env';
import { FeedbackButton } from '~/modules/global-search/components/SearchWrapper/components/FeedbackButton';

export function GlobalHeaderButtons() {
  const { t } = useTranslation('wmgone', {
    keyPrefix: 'globalHeader',
  });

  const productGuideUrl = env('VITE_WMG_PRODUCT_GUIDE_URL');
  const supportHubUrl = env('VITE_WMG_SUPPORT_HUB_URL');

  return (
    <div className="flex items-stretch gap-md justify-self-end">
      <FeedbackButton />
      {productGuideUrl || supportHubUrl ? (
        <Tooltip
          size="deprecated-help"
          spacing="thin"
          content={
            <>
              {productGuideUrl ? (
                <div
                  className={cn({
                    'mb-md border-b border-solid pb-md border-emphasis-subtle':
                      supportHubUrl,
                  })}
                >
                  <p className="mb-sm text-caption-md leading-tight">
                    {t('help.tooltip.productGuide.description')}
                  </p>
                  <a
                    href={productGuideUrl}
                    target="_blank"
                    rel="noreferrer noopener"
                    className="group mb-2xs inline-flex items-center gap-xs"
                  >
                    <div className="font-semibold underline underline-offset-4 group-hover:no-underline">
                      {t('help.tooltip.productGuide.link')}
                    </div>
                    <div className="pt-2xs">
                      <Icon type="arrow-up-right-from-square" size="sm" />
                    </div>
                  </a>
                </div>
              ) : null}
              {supportHubUrl ? (
                <div>
                  <p className="mb-sm text-caption-md">
                    {t('help.tooltip.supportHub.description')}
                  </p>
                  <a
                    href={supportHubUrl}
                    target="_blank"
                    rel="noreferrer noopener"
                    className="group mb-2xs inline-flex items-center gap-xs"
                  >
                    <div className="font-semibold underline underline-offset-4 group-hover:no-underline">
                      {t('help.tooltip.supportHub.link')}
                    </div>
                    <div className="pt-2xs">
                      <Icon type="arrow-up-right-from-square" size="sm" />
                    </div>
                  </a>
                </div>
              ) : null}
            </>
          }
          triggerAsChild
          sideOffset={8}
          alignOffset={-8}
          delayDuration={0}
          align="end"
          closeOnClick={false}
        >
          <div className="flex items-stretch">
            <Button variant="secondary" asChild>
              <button
                className="group grid aspect-square scale-110 grid-cols-1 grid-rows-1 place-items-center ease-out"
                aria-label={t('help.button')}
              >
                <div className="col-start-1 row-start-1 leading-[0] opacity-none duration-300 group-hover:opacity-full">
                  <Icon type="circle-question" variant="solid" size="sm" />
                </div>
                <div className="col-start-1 row-start-1 leading-[0] opacity-full duration-300 group-hover:opacity-none">
                  <Icon type="circle-question" variant="regular" size="sm" />
                </div>
              </button>
            </Button>
          </div>
        </Tooltip>
      ) : null}
    </div>
  );
}

GlobalHeaderButtons.displayName = 'GlobalHeaderButtons';
